module.exports = __webpack_public_path__ + "img/3.742ca360.jpg";